import React from "react";
import { ReactComponent as Plus } from "../assets/plus.svg";

interface KeywordSectionProps {
  keywords: string[];
  newKeyword: string;
  setNewKeyword: (keyword: string) => void;
  addKeyword: () => void;
  removeKeyword: (keyword: string) => void;
}

export default function KeywordSection({
  keywords,
  newKeyword,
  setNewKeyword,
  addKeyword,
  removeKeyword,
}: KeywordSectionProps) {
  return (
    <div
      className="keyword-section"
      style={{ gap: keywords.length > 0 ? "12px" : "0px" }}
    >
      <div className="keyword-input">
        <input
          type="text"
          placeholder="Type keyword here"
          value={newKeyword}
          onChange={(e) => setNewKeyword(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && addKeyword()}
        />
        <button onClick={addKeyword} className="add-keyword-button">
          <Plus />
        </button>
      </div>
      <div className="keywords">
        {keywords.map((keyword) => (
          <div key={keyword} className="keyword">
            {keyword}
            <button
              onClick={() => removeKeyword(keyword)}
              className="remove-keyword"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
